<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="help-detail">
      <h2 class="text-align-center">{{ form.questionTitle }}</h2>
      <el-divider></el-divider>
      <el-row :gutter="24" class="text-align-center" justify="center">
        <el-col :span="6" offset="6">
          问题类型: {{ dictMap["question_type"][form.questionType] }}
        </el-col>
        <el-col :span="6"> 发布时间: {{ form.createTime }} </el-col>
        <el-col :span="6"></el-col>
      </el-row>
      <el-row :gutter="24" justify="center">
        <el-col v-html="form.content"> </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import { getHelp } from "@/api/sysSupport/help"

export default {
  name: "Notice",
  components: { Breadcrumb },
  data() {
    return {
      form: {},
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      getHelp(this.$route.query.questionId).then((response) => {
        this.form = response.data
      })
    },
    goBack() {
      this.$router.go(-1)
    },
  },
}
</script>
<style lang="scss" scoped>
.text-align-center {
  text-align: center;
}
.help-detail {
  background: #ffffff;
  padding: 32px 16px 32px 16px;
  margin: 8px 0 0 0;
}
</style>
